import api from '../../ApiConfig';
import { Apis } from '../../../config';
import { NotificationManager } from 'react-notifications';

const getAllPaymentList = async () => {
    try {
        let result = await api.get(Apis.GetAllPaymentList);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};
const getTotalIncome = async () => {
    try {
        let result = await api.get(Apis.GetAllPaymentCount);
        if (result.errors) {
            NotificationManager.error(result.errors);
            return null;
        }
        return result.data; // Assuming the API response contains a `count` property
    } catch (error) {
        console.log(error);
        return null;
    }
};

export default {
    getAllPaymentList,
    getTotalIncome
};


// WEBPACK FOOTER //
// ./src/components/services/GetPaymentDetails/index.js